document.addEventListener("DOMContentLoaded", function () {
  var openTrigger = document.getElementById("staging-notice-modal-trigger");
  var modal = document.getElementById("first-visit");

  if (openTrigger && modal) {
    openTrigger.addEventListener("click", function (event) {
      event.preventDefault();
      modal.setAttribute("aria-hidden", "false");
      modal.classList.add("show");

      // Create the modal backdrop
      var backdrop = document.createElement("div");
      backdrop.className = "modal-backdrop fade show";
      document.body.appendChild(backdrop);
    });
  }

  // Ensure btnClose exists and attach the event listener
  document.addEventListener("click", function (event) {
    var btnClose = event.target.closest(".btn-close");
    if (btnClose && modal) {
      modal.classList.remove("show");
      modal.setAttribute("aria-hidden", "true");

      // Remove the modal backdrop
      var backdrop = document.querySelector(".modal-backdrop");
      if (backdrop) {
        backdrop.remove();
      }
    }
  });
});
